global.$ = global.jQuery = require('jquery');
global.Popper = require('popper.js');
require('./bootstrap-ak-lg');
window.PerfectScrollbar = require('perfect-scrollbar');
require('moment');
//window.Swal = require('sweetalert2');
window.Swal = require('sweetalert2/dist/sweetalert2.js');
require('jquery-validation');
require('./jquery.bootstrap-wizard');
require('bootstrap-select');
require('./bootstrap-datetimepicker.min');
//require( 'jszip' );
//require( 'pdfmake' );
//require( 'datatables.net' );
require( 'datatables.net-bs4' );
require( 'datatables.net-autofill-bs4' );
require( 'datatables.net-buttons' )();
require( 'datatables.net-buttons-bs4' )();
require( 'datatables.net-buttons/js/buttons.colVis.js' )();
require( 'datatables.net-buttons/js/buttons.flash.js' )();
require( 'datatables.net-buttons/js/buttons.html5.js' )();
require( 'datatables.net-buttons/js/buttons.print.js' )();
require( 'datatables.net-colreorder-bs4' );
require( 'datatables.net-fixedcolumns-bs4' );
require( 'datatables.net-fixedheader-bs4' );
require( 'datatables.net-keytable-bs4' );
require( 'datatables.net-responsive-bs4' );
require( 'datatables.net-rowgroup-bs4' );
require( 'datatables.net-rowreorder-bs4' );
require( 'datatables.net-scroller-bs4' );
require( 'datatables.net-searchbuilder-bs4' );
require( 'datatables.net-searchpanes-bs4' );
require( 'datatables.net-select-bs4' );
require('./bootstrap-tagsinput');
window.FullCalendar = require('@fullcalendar/core');
window.dayGridPlugin = require('@fullcalendar/daygrid');
window.timeGridPlugin = require('@fullcalendar/timegrid');
window.listPlugin = require('@fullcalendar/list');
window.scrollgridPlugin = require('@fullcalendar/scrollgrid');
window.interactionPlugin = require('@fullcalendar/interaction');
window.timelinePlugin = require('@fullcalendar/timeline');
window.adaptivePlugin = require('@fullcalendar/adaptive');
/*import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import scrollgridPlugin from '@fullcalendar/scrollgrid';
import interactionPlugin from '@fullcalendar/interaction';
import timelinePlugin from '@fullcalendar/timeline';
import adaptivePlugin from '@fullcalendar/adaptive';*/
require('./jquery-jvectormap');
window.noUiSlider = require('nouislider');
require('core-js');
require('arrive');
require('./github-buttons.min');
window.Chartist = require('./chartist.min');
window.bsCustomFileInput = require('bs-custom-file-input');
window.Handlebars = require('handlebars');
require( 'select2' );
require( 'select2/dist/js/i18n/pl' );
require('./bootstrap-notify');
require('./ak-lg');
require('./ak-lg-all');
require('./app');